function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 6.667 15 0l15 6.667v10c0 9.25-6.4 17.9-15 20-8.6-2.1-15-10.75-15-20v-10zm12.667 6.383a2.948 2.948 0 0 0-2.95-2.967A2.952 2.952 0 0 0 6.75 13.05 2.948 2.948 0 0 0 9.717 16a2.945 2.945 0 0 0 2.95-2.95zm4.75 10.65a2.959 2.959 0 0 0 2.95 2.967 2.973 2.973 0 0 0 2.966-2.967 2.959 2.959 0 0 0-2.966-2.95 2.945 2.945 0 0 0-2.95 2.95zm-10.75.517 2.5 2.5L23.383 12.5l-2.5-2.5L6.667 24.217z"
});

function SvgShieldPercent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldPercent);
export default __webpack_public_path__ + "static/media/shieldPercent.642cbed0.svg";
export { ForwardRef as ReactComponent };